import { render } from "./Langdrop.vue?vue&type=template&id=590c48ec&scoped=true"
import script from "./Langdrop.vue?vue&type=script&lang=js"
export * from "./Langdrop.vue?vue&type=script&lang=js"

import "./Langdrop.vue?vue&type=style&index=0&id=590c48ec&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-590c48ec"]])

export default __exports__